import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router) { }

  canActivate(): Promise<boolean> | boolean {
    return new Promise(async (resolve) => {
      const authenticated = await this.auth.isAuthenticated();
      if (!authenticated) {
        this.router.navigate(['login']);
        resolve(false);
      }
      resolve(true)
    })
  }
}
